{
    "Accessibility menu": "Menuya Gihîştinê",
    "Close": "Bigire",
    "Text and Reading": "Nivîs û xwendin",
    "Navigation and Interaction": "Rêveçûn û têkilî",
    "Text Align": "Hîzakirina nivîsê",
    "Align Left": "Hîzakirina çepê",
    "Align Center": "Hîzakirina navendê",
    "Align Right": "Hîzakirina rastê",
    "Adjust Font Size": "Mezinahiya Fontê biguherîne",
    "Highlight Title": "Sernavê nîşan bide",
    "Highlight Links": "Girêdanên nîşan bide",
    "Readable Font": "Fonta Xwendbar",
    "Color and Contrast": "Reng û tezad",
    "Dark Contrast": "Kontrasta Tarî",
    "Light Contrast": "Kontrasta Ronahî",
    "High Contrast": "Kontrasta Bilind",
    "High Saturation": "Saturasyona Bilind",
    "Low Saturation": "Saturasyona Nizm",
    "Monochrome": "Rengê Yekane",
    "Tools": "Amûr",
    "Reading Guide": "Rêbera Xwendinê",
    "Big Cursor": "Kursorê Mezin",
    "Increase Font Size": "Mezinahiya Fontê Zêde Bike",
    "Decrease Font Size": "Mezinahiya Fontê Kêm Bike",
    "Letter Spacing": "Dûrahiya Tîpan",
    "Line Height": "Bilindahiya Rêzê",
    "Font Weight": "Giraniya Fontê",
    "Dyslexia Font": "Fonta Disleksiya",
    "Language": "Ziman",
    "Accessibility widget": "Menuya Gihîştinê Veke",
    "Accessibility Profiles": "Profîlên Gihîştinê",
    "Cognitive Disability": "Seqetiya Zanînî",
    "Seizure Safe": "Ji bo Epilepsî Ewle",
    "Accessibility statement": "Daxuyaniya Gihîştinê",
    "ADHD": "ADHD",
    "Low Vision": "Dîtina lawaz",
    "Pause Animations": "Anîmasyonan Rawestîne",
    "Animation paused": "Anîmasyon hat rawestandin",
    "Reset all settings": "Hemî Mîhengan Vegerîne",
    "Shortcut:": "Kurtebir:",
    "Epilepsy Safe Mode": "Moda ewle ji bo epîlepsiyê",
    "Mute sounds": "Dengan bêdeng bike",
    "Page read": "Xwendina rûpelê",
    "Page read controls": "Kontrolên xwendina rûpelê",
    "Pause": "Rawestandin",
    "Resume": "Berdewamkirin",
    "Stop": "Bisekine",
    "Settings": "Mîheng",
    "Speed": "Lez",
    "Voice": "Deng",
    "Close accessibility menu": "Menuya gihîştinê bigire",
    "Back to accessibility menu": "Vegere menuya gihîştinê",
    "Search languages": "Li zimanan bigere",
    "Selected language": "Zimanê hilbijartî",
    "View accessibility statement (opens in new window)": "Daxuyaniya gihîştinê bibîne (di pencereyeke nû de vedibe)",
    "Visit CookieYes website (opens in new window)": "Serdana malpera CookieYes bike (di pencereyeke nû de vedibe)",
    "Reset all accessibility settings to default": "Hemî mîhengên gihîştinê vegerîne bo standard"
}
